import React from 'react'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import Sidebar from '../Sidebar'

@inject('User')
@observer
export class NewsContainer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    return (
      <Row>
        <Col xs='12' lg='3'>
          <Sidebar
            hide={this.props.hide}
            location={this.props.location}
            match={this.props.match}
            permissions={(this.props.User.me || {}).permissions}
          />
        </Col>
        <Col>
          <Row>
            <Col lg='1' className={`d-none d-lg-block`} />
            <Col>{this.props.children}</Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

export default NewsContainer



// WEBPACK FOOTER //
// ./src/components/News/partials/Container/index.js